import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const reportId = "labels-per-date";
const reportName = "Marcações de passagens por data";
const LabelsPerDate = ({ data }) => {
  useEffect(() => {
    const allLabels = [];
    const allValues = [];

    for (const item of data) {
      allLabels.push(item.date);
      allValues.push(item.total);
    }


    GraphicUtils.lineChart(reportId, [["Marcação veicular por dia", ...allValues]],allLabels, "Data de marcação", "Quantidade de marcações", );
    data && data.length > 0 && ReportUtils.createExportableTable(allLabels, allValues, `Marcações por dia`, );
  }, [data])

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">{reportName}</span>
        <div className="mt-3" id={reportId}></div>
      </div>
    </>
  );
};

export default LabelsPerDate;